// extracted by mini-css-extract-plugin
export default {"itemsMainWrapper":"style_itemsMainWrapper__Q3yUf","itemWrapper":"style_itemWrapper__akLSY"};